import * as React from "react";
import styled from "@emotion/styled";
import breakpoint from "@/utils/breakpoint";

const StyledTitle = styled.div<{ color?: string }>`
  border-left: ${({ color = "#333333" }) => `4px solid ${color}`};
  margin-top: 30px;
  padding-left: 10px;
  margin-bottom: 15px;
  height: 24px;
  color: #333333;
  font-weight: 700;
  font-size: 16px;
  &: first-child {
    margin-top: 27px;
    margin-bottom: 15px;
  }
  ${breakpoint.lessThan("sm")`
  margin-left: 15px;  
  `}
  &.marginLeftZero {
    margin-left: 0px;
  }
`;

export interface IProps {
  color?: string;
  children: React.ReactNode;
  className?: string;
}
export default (props: IProps) => (
  <StyledTitle color={props.color} className={props.className}>
    {props.children}
  </StyledTitle>
);
